/**
 * Cognito Hosted UI redirects here with `?code=…` after the user signs in.
 * react-oidc-context's AuthProvider handles the code-exchange automatically;
 * the page shows a loader until that completes and then navigates away (the
 * onSigninCallback in oidcConfig sends the user to the page they originally
 * requested — DE-169, round-tripped via OIDC `state` — defaulting to `/`).
 *
 * If Cognito or an upstream IdP rejects the sign-in (e.g. the Pre-Sign-Up
 * Lambda returns "user not invited"), the redirect carries `?error=...` and
 * `?error_description=...`. We surface that on a friendly card with a link
 * back to the email-first form, instead of leaving the user on a perpetual
 * "Signing in…" spinner.
 */

import { useMemo } from 'react';

export function AuthCallback() {
  const errorDesc = useMemo(() => {
    const params = new URLSearchParams(window.location.search);
    return params.get('error_description') || params.get('error');
  }, []);

  if (errorDesc) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="card max-w-md w-full text-center">
          <img
            src="/artome-logo.png"
            alt="Artome"
            className="mx-auto mb-4 h-10 w-auto"
          />
          <h1 className="text-xl font-semibold mb-2">Sign-in not permitted</h1>
          <p className="text-sm text-muted mb-6 whitespace-pre-line">
            {decodeURIComponent(errorDesc)}
          </p>
          <a
            href="/"
            className="inline-block w-full px-3 py-2 bg-accent text-white rounded-md text-sm font-medium hover:bg-accent/90"
          >
            Use a different email
          </a>
        </div>
      </div>
    );
  }

  return (
    <div className="min-h-screen flex items-center justify-center text-muted">
      <p className="text-sm">Signing in…</p>
    </div>
  );
}
